<template>
  <div v-if="settings && settings.length > 0" class="settings-section">
    <div class="section-header">
      <h3 class="section-title">{{ $t("globals.settings") }}</h3>
    </div>
    <div class="table-wrapper">
      <table class="modern-table settings-table">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(setting, index) in settings" :key="index">
            <td>{{ setting.key }}</td>
            <td>{{ setting.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
/* Component-specific styles only - shared styles in modern-table.css */
</style>
